import React from 'react';
import { Text, TextVariant } from '../components/text/Text.tsx';

export const formatContent = (content?: string, variant: TextVariant = 'body') => {
  if (content === undefined) {
    return null;
  }

  const renderFormattedText = (text: string) => {
    // Split by <tab> first to handle them as spans (for tabs in the middle of text)
    const tabParts = text.split(/(<tab>)/g);

    return tabParts.flatMap((part, i) => {
      if (part === '<tab>') {
        return <span key={`tab-${i}`} style={{ display: 'inline-block', width: 8 }} />;
      }

      // Handle bold and italic tags
      const boldParts = part.split(/(<b>|<\/b>)/g);
      let isBold = false;
      return boldParts.flatMap((boldPart, j) => {
        if (boldPart === '<b>') {
          isBold = true;
          return null;
        }
        if (boldPart === '</b>') {
          isBold = false;
          return null;
        }

        const italicParts = boldPart.split(/(<i>|<\/i>)/g);
        let isItalic = false;
        return italicParts.map((italicPart, k) => {
          if (italicPart === '<i>') {
            isItalic = true;
            return null;
          }
          if (italicPart === '</i>') {
            isItalic = false;
            return null;
          }

          if (isBold || isItalic) {
            return (
              <span 
                key={`text-${i}-${j}-${k}`} 
                style={{ 
                  fontWeight: isBold ? 'bold' : 'normal', 
                  fontStyle: isItalic ? 'italic' : 'normal' 
                }}
              >
                {italicPart}
              </span>
            );
          }
          return italicPart;
        }).filter(p => p !== null);
      }).filter(p => p !== null);
    }).filter(p => p !== null);
  };

  return (
    <div>
      {content.split('<end>').map((line, i) => {
        let tabCount = 0;
        let lineContent = line.trimStart(); // Trim leading whitespace from code formatting

        // Count and remove leading <tab> tags to use as padding
        while (lineContent.startsWith('<tab>')) {
          tabCount++;
          lineContent = lineContent.substring(5);
        }

        return (
          <div
            key={i}
            style={{
              paddingLeft: tabCount * 8,
              display: 'block',
            }}
          >
            <Text variant={variant}>{renderFormattedText(lineContent)}</Text>
          </div>
        );
      })}
    </div>
  );
};
